{"name":"master","accountHash":"3202592","servicePatchUrl":"https://s3.eu-west-2.amazonaws.com/3202592.master.servicepatchstack.servicepatch"}